import {Layout} from '../../components/LayoutComponents';

export const WhiteboardPage: React.FC = () => {
  return <Layout pageTitle='Whiteboard' paddingBottom></Layout>;
};
